﻿import { createSignal } from 'solid-js';

// debounce hook
type DebounceHook<T extends any[]> = (...args: T) => void;

export function createDebounce<T extends any[] = any[]>(callback: (...args: T) => void, delay: number): DebounceHook<T> {
    const [tid, setTid] = createSignal<number | null>(null);

    return (...args) => {
        const id = tid();
        if (id != null) {
            clearTimeout(id);
        }

        const timeout = window.setTimeout(() => {
            callback(...args);
            setTid(null);
        }, delay);

        setTid(timeout);
    };
}
